import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

export const JsonTable = props => {
  let th = '';
  let td = '';

  const { Data } = props;

  Data.forEach(item => {
    if (item) {
      if (Array.isArray(item)) {
        item.forEach(itemEach => {
          th += `<th class="text-capitalize">${itemEach.Key}</th>`;
          td += `<td>${itemEach.Value}</td>`;
        });
      } else {
        Object.keys(item).forEach(key => {
          th += `<th class="text-capitalize">${key}</th>`;
          td += `<td>${item[key]}</td>`;
        });
      }
    }
  });

  return (
    <table className="table tp-table table-striped mb-0 tp-table-scroll">
      <tbody>
        <tr>{ReactHtmlParser(th)}</tr>
        <tr>{ReactHtmlParser(td)}</tr>
      </tbody>
    </table>
  );
};

JsonTable.propTypes = {
  Data: PropTypes.array.isRequired,
};

// eslint-disable-next-line no-extend-native, func-names
String.prototype.format = function (format) {
  let value = this;

  switch (format.toLowerCase()) {
    case 'c':
    case 'currency':
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      break;
    default:
      break;
  }
  return value;
};
// eslint-disable-next-line no-extend-native, func-names
Number.prototype.format = function (format) {
  let value = this;

  switch (format.toLowerCase()) {
    case 'c':
    case 'currency':
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      break;
    default:
      break;
  }
  return value;
};
